"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialOnboardingWizard = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/site-menu/component");
const component_2 = require("@front/components/form-parts/form/component");
const events_1 = require("@front/components/form-parts/events");
const tutorial_onboarding_types_1 = __importDefault(require("./types/tutorial-onboarding.types"));
const NUMERIC_FIELDS = ['params.lessonMinutes'];
const TUT = 'tutorial.form.onboarding';
const buildOptions = (group, values) => values.map(value => ({ label: `${TUT}.${group}.${value}`.t(), value }));
//@ts-ignore                
let rwsTemplate = T.html `<div id="tutorial-onboarding-wizard">
    <a href="#" class="editor-back" @click="${x => x.cancel()}">
        <i class="simple-icon-arrow-left"></i>
        ${() => 'tutorial.form.backToList'.t()}
    </a>

    <the-form :onSubmit="${x => x.handleSubmit.bind(x)}">
        ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
        <div class="scan-overlay">
            <app-loader block="true" width="40px" height="40px"></app-loader>
            ${(0, fast_element_1.when)(x => x.scanProgressPhase !== '', (0, fast_element_1.html) `
            <div class="scan-progress">
                ${x => `tutorial.form.scanProgress.${x.scanProgressPhase}`.t()}
                ${(0, fast_element_1.when)(x => x.scanProgressTotalSections > 0 && x.scanProgressPhase === 'content', (0, fast_element_1.html) `
                · ${() => 'tutorial.form.scanProgress.section'.t()} ${x => x.scanProgressCurrentSection}/${x => x.scanProgressTotalSections}
                `)}
            </div>
            `)}
        </div>
        `)}
        <div class="editor-main" ?loading="${x => x.loading}">
            <div class="editor-head">
                <div class="min-w-0">
                    <h1>${() => 'tutorial.form.onboarding.title'.t()}</h1>
                    <p>${x => x.currentStepHint}</p>
                </div>
                <div class="editor-actions" id="headActions">
                    <button type="button" class="btn btn-outline-brand" @click="${x => x.cancel()}">
                        ${() => 'common.cancel'.t()}
                    </button>
                    <button type="submit" class="btn btn-brand btn-icon" @click="${(x, c) => x.sendSubmit(x, c)}">
                        <i class="simple-icon-check"></i> ${() => 'tutorial.form.onboarding.submit'.t()}
                    </button>
                </div>
            </div>

            <div class="tutorial-form-carousel">
                <div class="tutorial-form-carousel-track">
                    
                    <div class="tutorial-form-slide" ?active="${x => x.currentStepIndex === 0}" ?inert="${x => x.currentStepIndex !== 0}">
                        <section class="editor-card wizard-card">
                            <div class="editor-card-title">
                                <h3><span class="step-pill">1</span> ${() => 'tutorial.form.onboarding.step1'.t()}</h3>
                                <span class="wizard-of">${() => 'tutorial.form.onboarding.step'.t()} 1 ${() => 'tutorial.form.onboarding.of'.t()} 7</span>
                            </div>
                            <div class="row g-4">
                                <div class="col-md-6">
                                    <div class="w-field">
                                        <div class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.name'.t()}</span></div>
                                        <part-input class="form-part" name="basics.name" label="${() => 'tutorial.form.onboarding.name'.t()}" :value="${x => x.form.basics.name}" required="true"></part-input>
                                    </div>
                                    <div class="w-field">
                                        <div class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.desc'.t()}</span></div>
                                        <part-textarea class="form-part" name="basics.description" label="${() => 'tutorial.form.onboarding.description'.t()}" maxlength="2000" rows="6" :value="${x => x.form.basics.description}"></part-textarea>
                                        <div class="char-count"><span>${x => x.getCharCount('basics.description')}</span> / 2000</div>
                                    </div>
                                    <div class="w-field">
                                        <div class="w-info"><i class="simple-icon-info"></i><span>${() => 'tutorial.form.source.file.description'.t()}</span></div>
                                        <part-file-upload name="sourceFile"
                                            label="${() => 'tutorial.form.sourceFile.label'.t()}"
                                            placeholder="${() => 'tutorial.form.sourceFile.placeholder'.t()}"
                                            :value="${x => x.sourceFile}"
                                            :onSelectFile="${x => x.onSourceFileUpload.bind(x)}"></part-file-upload>
                                    </div>
                                    <div class="w-field">
                                        <div class="fl-group">
                                            <div class="fl-group-label">${() => 'tutorial.form.scanPages.label'.t()}</div>
                                            <div class="page-range">
                                                <part-input type="number" class="no-margin small" name="scanPagesFrom"
                                                    :value="${x => { var _a; return (_a = x.scanPagesFrom) !== null && _a !== void 0 ? _a : ''; }}"></part-input>
                                                <span>–</span>
                                                <part-input type="number" class="no-margin small" name="scanPagesTo"
                                                    :value="${x => { var _a; return (_a = x.scanPagesTo) !== null && _a !== void 0 ? _a : ''; }}"></part-input>
                                            </div>
                                        </div>
                                        <div class="w-info scan-field-description"><i class="simple-icon-info"></i><span>${() => 'tutorial.form.scanSourceFile.description.file'.t()}</span></div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="w-field">
                                        <part-select class="form-part" name="basics.categoryId" label="${() => 'tutorial.form.onboarding.category'.t()}" :value="${x => { var _a; return ((_a = x.form.basics.categoryId) === null || _a === void 0 ? void 0 : _a.toString()) || ''; }}" :options="${x => x.categoryOptions}">
                                            <div slot="info" class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.category'.t()}</span></div>
                                        </part-select>
                                    </div>
                                    <div class="w-field">
                                        <part-select class="form-part" name="basics.avatarId" required="true" label="${() => 'tutorial.form.avatar'.t()}" :value="${x => { var _a; return ((_a = x.form.basics.avatarId) === null || _a === void 0 ? void 0 : _a.toString()) || ''; }}" :options="${x => [
    { value: '', label: 'tutorial.form.selectAvatar'.t() },
    ...x.availableAvatars.map(avatar => { var _a; return ({ value: ((_a = avatar.id) === null || _a === void 0 ? void 0 : _a.toString()) || '', label: avatar.name }); })
]}">
                                            <div slot="info" class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.avatar'.t()}</span></div>
                                        </part-select>
                                    </div>
                                    <div class="w-field">
                                        <part-checkbox hoverevent="true" class="form-part" multiple="true" name="basics.goals" label="${() => 'tutorial.form.onboarding.goals'.t()}" :value="${x => x.form.basics.goals}" :options="${x => x.goalOptions}">
                                            <div slot="info" class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.goals'.t()}</span></div>
                                        </part-checkbox>
                                        <part-option-info name="basics.goals" placeholder="${'tutorial_form.optinfo.placeholder'.t()}"></part-option-info>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    
                    <div class="tutorial-form-slide" ?active="${x => x.currentStepIndex === 1}" ?inert="${x => x.currentStepIndex !== 1}">
                        <section class="editor-card wizard-card">
                            <div class="editor-card-title">
                                <h3><span class="step-pill">2</span> ${() => 'tutorial.form.onboarding.step2'.t()}</h3>
                                <span class="wizard-of">${() => 'tutorial.form.onboarding.step'.t()} 2 ${() => 'tutorial.form.onboarding.of'.t()} 7</span>
                            </div>
                            <div class="row g-4">
                                <div class="col-md-6">
                                    <div class="w-field">
                                        <part-radio hoverevent="true" class="form-part" name="audience.level" label="${() => 'tutorial.form.onboarding.level'.t()}" :value="${x => x.form.audience.level}" :options="${x => x.levelOptions}">
                                            <div slot="info" class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.level'.t()}</span></div>
                                        </part-radio>
                                        <part-option-info name="audience.level" placeholder="${'tutorial_form.optinfo.placeholder'.t()}"></part-option-info>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="w-field">
                                        <part-select hoverevent="true" class="form-part" name="audience.participants" label="${() => 'tutorial.form.onboarding.participants'.t()}" :value="${x => x.form.audience.participants}" :options="${x => x.participantsOptions}">
                                            <div slot="info" class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.participants'.t()}</span></div>
                                        </part-select>
                                        <part-option-info name="audience.participants" placeholder="${'tutorial_form.optinfo.placeholder'.t()}"></part-option-info>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="w-field">
                                        <part-checkbox hoverevent="true" class="form-part" multiple="true" name="audience.industries" label="${() => 'tutorial.form.onboarding.industries'.t()}" :value="${x => x.form.audience.industries}" :options="${x => x.industryOptions}">
                                            <div slot="info" class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.industries'.t()}</span></div>
                                        </part-checkbox>
                                        <part-option-info name="audience.industries" placeholder="${'tutorial_form.optinfo.placeholder'.t()}"></part-option-info>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="w-field">
                                        <part-checkbox hoverevent="true" class="form-part" multiple="true" name="audience.targetGroups" label="${() => 'tutorial.form.onboarding.targetGroups'.t()}" :value="${x => x.form.audience.targetGroups}" :options="${x => x.targetGroupOptions}">
                                            <div slot="info" class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.targetGroups'.t()}</span></div>
                                        </part-checkbox>
                                        <part-option-info name="audience.targetGroups" placeholder="${'tutorial_form.optinfo.placeholder'.t()}"></part-option-info>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    
                    <div class="tutorial-form-slide" ?active="${x => x.currentStepIndex === 2}" ?inert="${x => x.currentStepIndex !== 2}">
                        <section class="editor-card wizard-card">
                            <div class="editor-card-title">
                                <h3><span class="step-pill">3</span> ${() => 'tutorial.form.onboarding.step3'.t()}</h3>
                                <span class="wizard-of">${() => 'tutorial.form.onboarding.step'.t()} 3 ${() => 'tutorial.form.onboarding.of'.t()} 7</span>
                            </div>
                            <div class="row g-4">
                                <div class="col-md-6">
                                    <div class="w-field range-field">
                                        <div class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.totalHours'.t()}</span></div>
                                        <part-slider class="form-part" name="params.totalHours" label="${() => 'tutorial.form.onboarding.totalHours'.t()}" min="1" max="100" step="1" unit="h" :value="${x => x.form.params.totalHours}"></part-slider>
                                    </div>
                                    <div class="w-field range-field">
                                        <div class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.lessonsPerModule'.t()}</span></div>
                                        <part-slider class="form-part" name="params.lessonsPerModule" label="${() => 'tutorial.form.onboarding.lessonsPerModule'.t()}" min="1" max="30" step="1" unit="" :value="${x => x.form.params.lessonsPerModule}"></part-slider>
                                        <div class="alert alert-warning">
                                            <i class="simple-icon-exclamation"></i>
                                            <span>${x => x.courseEstimate}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="w-field range-field">
                                        <div class="w-info"><strong><i class="simple-icon-bulb"></i></strong><span>${() => 'tutorial.form.onboarding.info.modulesCount'.t()}</span></div>
                                        <part-slider class="form-part" name="params.modulesCount" label="${() => 'tutorial.form.onboarding.modulesCount'.t()}" min="1" max="50" step="1" unit="" :value="${x => x.form.params.modulesCount}"></part-slider>
                                    </div>
                                    <div class="w-field">
                                        <part-radio grid="true" hoverevent="true" class="form-part" name="params.lessonMinutes" label="${() => 'tutorial.form.onboarding.lessonMinutes'.t()}" :value="${x => x.form.params.lessonMinutes}" :options="${x => x.lessonDurationOptions}">
                                            <div slot="info" class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.lessonMinutes'.t()}</span></div>
                                        </part-radio>
                                        <part-option-info inline="true" name="params.lessonMinutes" placeholder="${'tutorial_form.optinfo.placeholder'.t()}"></part-option-info>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="w-field">
                                        <part-radio inline="true" hoverevent="true" class="form-part " name="params.intensity" label="${() => 'tutorial.form.onboarding.intensity'.t()}" :value="${x => x.form.params.intensity}" :options="${x => x.intensityOptions}">
                                            <div slot="info" class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.intensity'.t()}</span></div>
                                        </part-radio>
                                        <part-option-info name="params.intensity" placeholder="${'tutorial_form.optinfo.placeholder'.t()}"></part-option-info>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    
                    <div class="tutorial-form-slide" ?active="${x => x.currentStepIndex === 3}" ?inert="${x => x.currentStepIndex !== 3}">
                        <section class="editor-card wizard-card">
                            <div class="editor-card-title">
                                <h3><span class="step-pill">4</span> ${() => 'tutorial.form.onboarding.step4'.t()}</h3>
                                <span class="wizard-of">${() => 'tutorial.form.onboarding.step'.t()} 4 ${() => 'tutorial.form.onboarding.of'.t()} 7</span>
                            </div>
                            <div class="row g-4">
                                <div class="col-md-6">
                                    <div class="w-field">
                                        <part-checkbox hoverevent="true" class="form-part " multiple="true" name="style.styles" label="${() => 'tutorial.form.onboarding.styles'.t()}" :value="${x => x.form.style.styles}" :options="${x => x.styleOptions}">
                                            <div slot="info" class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.styles'.t()}</span></div>
                                        </part-checkbox>
                                        <part-option-info name="style.styles" placeholder="${'tutorial_form.optinfo.placeholder'.t()}"></part-option-info>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="w-field">
                                        <part-radio hoverevent="true" class="form-part " name="style.tone" label="${() => 'tutorial.form.onboarding.tone'.t()}" :value="${x => x.form.style.tone}" :options="${x => x.toneOptions}">
                                            <div slot="info" class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.tone'.t()}</span></div>
                                        </part-radio>
                                        <part-option-info name="style.tone" placeholder="${'tutorial_form.optinfo.placeholder'.t()}"></part-option-info>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    
                    <div class="tutorial-form-slide" ?active="${x => x.currentStepIndex === 4}" ?inert="${x => x.currentStepIndex !== 4}">
                        <section class="editor-card wizard-card">
                            <div class="editor-card-title">
                                <h3><span class="step-pill">5</span> ${() => 'tutorial.form.onboarding.step5'.t()}</h3>
                                <span class="wizard-of">${() => 'tutorial.form.onboarding.step'.t()} 5 ${() => 'tutorial.form.onboarding.of'.t()} 7</span>
                            </div>
                            <div class="row g-4">
                                <div class="col-md-12">
                                    <div class="w-field">
                                        <div class="fl-group-label fw-bold">
                                            ${() => 'tutorial.form.onboarding.materials'.t()}
                                            <button type="button" class="btn btn-link-brand bulk-link" @click="${x => x.toggleAllMaterials()}">
                                                ${x => x.areAllMaterialsSelected() ? 'tutorial.form.onboarding.deselectAll'.t() : 'tutorial.form.onboarding.selectAll'.t()}
                                            </button>
                                        </div>
                                        <part-checkbox grid="true" hoverevent="true" class="form-part " multiple="true" name="materials" :value="${x => x.form.materials}" :options="${x => x.materialOptions}">
                                            <div slot="info" class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.materials'.t()}</span></div>
                                        </part-checkbox>
                                        <part-option-info name="materials" placeholder="${'tutorial_form.optinfo.placeholder'.t()}"></part-option-info>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    
                    <div class="tutorial-form-slide" ?active="${x => x.currentStepIndex === 5}" ?inert="${x => x.currentStepIndex !== 5}">
                        <section class="editor-card wizard-card">
                            <div class="editor-card-title">
                                <h3><span class="step-pill">6</span> ${() => 'tutorial.form.onboarding.step6'.t()}</h3>
                                <span class="wizard-of">${() => 'tutorial.form.onboarding.step'.t()} 6 ${() => 'tutorial.form.onboarding.of'.t()} 7</span>
                            </div>
                            <div class="row g-4">
                                <div class="col-md-6">
                                    <div class="w-field range-field">
                                        <div class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.theoryPracticeRatio'.t()}</span></div>
                                        <div class="fl-group-label">${() => 'tutorial.form.onboarding.theoryPracticeRatio'.t()}</div>
                                        <part-slider class="form-part" name="learningModel.theoryPracticeRatio" min="0" max="100" step="5" unit="%" minLabel="${x => x.getTheoryScale().left}" maxLabel="${x => x.getTheoryScale().right}" :value="${x => x.form.learningModel.theoryPracticeRatio}"></part-slider>
                                    </div>
                                    <div class="w-field range-field">
                                        <div class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.caseStudiesCount'.t()}</span></div>
                                        <part-slider class="form-part" name="learningModel.caseStudiesCount" label="${() => 'tutorial.form.onboarding.caseStudiesCount'.t()}" min="0" max="50" step="1" unit="" :value="${x => x.form.learningModel.caseStudiesCount}"></part-slider>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="w-field range-field">
                                        <div class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.exercisesCount'.t()}</span></div>
                                        <part-slider class="form-part" name="learningModel.exercisesCount" label="${() => 'tutorial.form.onboarding.exercisesCount'.t()}" min="0" max="100" step="1" unit="" :value="${x => x.form.learningModel.exercisesCount}"></part-slider>
                                    </div>
                                    <div class="w-field">
                                        <div class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.finalProject'.t()}</span></div>
                                        <part-switch class="form-part" name="learningModel.finalProject" label="${() => 'tutorial.form.onboarding.finalProject'.t()}" :value="${x => x.form.learningModel.finalProject}"></part-switch>
                                    </div>
                                    <div class="w-field">
                                        <div class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.finalExam'.t()}</span></div>
                                        <part-switch class="form-part" name="learningModel.finalExam" label="${() => 'tutorial.form.onboarding.finalExam'.t()}" :value="${x => x.form.learningModel.finalExam}"></part-switch>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    
                    <div class="tutorial-form-slide" ?active="${x => x.currentStepIndex === 6}" ?inert="${x => x.currentStepIndex !== 6}">
                        <section class="editor-card wizard-card">
                            <div class="editor-card-title">
                                <h3><span class="step-pill">7</span> ${() => 'tutorial.form.onboarding.step7'.t()}</h3>
                                <span class="wizard-of">${() => 'tutorial.form.onboarding.step'.t()} 7 ${() => 'tutorial.form.onboarding.of'.t()} 7</span>
                            </div>
                            <div class="row g-4">
                                <div class="col-md-6">
                                    <div class="w-field">
                                        <div class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.certificate'.t()}</span></div>
                                        <part-switch class="form-part" name="certification.certificate" label="${() => 'tutorial.form.onboarding.certificate'.t()}" :value="${x => x.form.certification.certificate}"></part-switch>
                                    </div>
                                    <div class="w-field ${x => !x.isCertificateEnabled() ? 'is-disabled' : ''}">
                                        <div class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.numbered'.t()}</span></div>
                                        <part-switch class="form-part" name="certification.numbered" label="${() => 'tutorial.form.onboarding.numbered'.t()}" :value="${x => x.form.certification.numbered}" :disabled="${x => !x.isCertificateEnabled()}"></part-switch>
                                    </div>
                                    <div class="w-field ${x => !x.isCertificateEnabled() ? 'is-disabled' : ''}">
                                        <div class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.qrVerification'.t()}</span></div>
                                        <part-switch class="form-part" name="certification.qrVerification" label="${() => 'tutorial.form.onboarding.qrVerification'.t()}" :value="${x => x.form.certification.qrVerification}" :disabled="${x => !x.isCertificateEnabled()}"></part-switch>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="w-field range-field ${x => !x.isCertificateEnabled() ? 'is-disabled' : ''}">
                                        <div class="w-info"><i class="simple-icon-bulb"></i><span>${() => 'tutorial.form.onboarding.info.passThreshold'.t()}</span></div>
                                        <div class="fl-group-label">${() => 'tutorial.form.onboarding.passThreshold'.t()}</div>
                                        <part-slider class="form-part" name="certification.passThreshold" min="50" max="100" step="5" unit="%" :value="${x => x.form.certification.passThreshold}" :disabled="${x => !x.isCertificateEnabled()}"></part-slider>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>

        <div class="editor-foot-actions">
            <div class="efa-hint">
                ${x => x.currentStepIndex === 0
    ? 'tutorial.form.basicInfo'.t()
    : 'tutorial.form.onboarding.step'.t() + ' ' + (x.currentStepIndex + 1) + ' / ' + x.wizardSteps.length + ' · ' + x.wizardSteps[x.currentStepIndex].title}
            </div>
            <div class="editor-actions">
                <button type="button" class="btn btn-outline-brand" @click="${x => x.cancel()}">
                    ${() => 'common.cancel'.t()}
                </button>
                <button type="submit" class="btn btn-brand btn-icon" @click="${(x, c) => x.sendSubmit(x, c)}">
                    <i class="simple-icon-check"></i> ${() => 'tutorial.form.onboarding.submit'.t()}
                </button>
            </div>
        </div>
    </the-form>

    <div class="editor-nav">
        <div class="editor-nav-progress"><span style="${x => 'width: ' + x.progressPercent + '%'}"></span></div>
        <div class="container editor-nav-inner">
            <button type="button" class="btn nav-arrow" @click="${x => x.prevStep()}" :disabled="${x => !x.canGoPrev}">
                <i class="simple-icon-arrow-left"></i>
                <span class="d-none d-sm-inline">${() => 'tutorial.form.previous'.t()}</span>
            </button>

            <div class="dropup slide-picker">
                <button type="button" class="slide-picker-toggle" @click="${(x, c) => x.toggleStepMenu(c.event)}"
                    aria-expanded="${x => x.isStepMenuOpen ? 'true' : 'false'}">
                    <span class="sp-num">${x => x.currentStepIndex + 1}</span>
                    <span class="sp-text">
                        <small>${() => 'tutorial.form.onboarding.step'.t()} ${x => x.currentStepIndex + 1} ${() => 'tutorial.form.onboarding.of'.t()} ${x => x.wizardSteps.length}</small>
                        <strong>${x => x.wizardSteps[x.currentStepIndex].title}</strong>
                    </span>
                    <i class="simple-icon-arrow-down sp-caret"></i>
                </button>
                <ul class="dropdown-menu slide-picker-menu${x => x.isStepMenuOpen ? ' show' : ''}">
                    ${(0, fast_element_1.repeat)(x => x.wizardSteps, (0, fast_element_1.html) `
                    <li>
                        <button type="button" class="slide-item${(step, c) => c.parent.currentStepIndex === c.index ? ' active' : ''}" @click="${(step, c) => c.parent.goToStep(c.index)}">
                            <span class="sp-num">${(step, c) => c.index + 1}</span>
                            <span class="sp-text">
                                <strong>${step => step.title}</strong>
                                <small>${step => step.hint}</small>
                            </span>
                        </button>
                    </li>
                    `, { positioning: true })}
                </ul>
            </div>

            <button type="button" class="btn nav-arrow nav-arrow-next" @click="${x => x.nextStep()}" :disabled="${x => !x.canGoNext}">
                <span class="d-none d-sm-inline">${() => 'tutorial.form.next'.t()}</span>
                <i class="simple-icon-arrow-right"></i>
            </button>
        </div>
    </div>

    <div class="${x => 'editor-toast' + (x.toastMessage ? (x.toastError ? ' is-error show' : ' show') : '')}">
        <i class="${x => 'simple-icon-' + (x.toastError ? 'exclamation' : 'check')}"></i>
        ${x => x.toastMessage}
    </div>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `#tutorial-onboarding-wizard {
  display: block;
  padding: 24px;
  background: var(--bg);
  min-height: 100vh;
}
#tutorial-onboarding-wizard [loading] {
  opacity: 0.6;
  pointer-events: none;
}
#tutorial-onboarding-wizard .scan-overlay {
  position: fixed;
  inset: 0;
  z-index: 1060;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
}
#tutorial-onboarding-wizard .scan-progress {
  max-width: 90vw;
  text-align: center;
  color: var(--ink);
  font-size: 0.95rem;
  font-weight: 500;
}
#tutorial-onboarding-wizard .editor-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 0.85rem;
  color: var(--muted);
  text-decoration: none;
}
#tutorial-onboarding-wizard .editor-back:hover {
  color: var(--brand);
}
#tutorial-onboarding-wizard .editor-back i {
  font-size: 0.75rem;
}
#tutorial-onboarding-wizard .editor-main {
  padding-bottom: 24px;
}
#tutorial-onboarding-wizard .editor-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}
#tutorial-onboarding-wizard .editor-head h1 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 2px;
}
#tutorial-onboarding-wizard .editor-head p {
  margin: 0;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#tutorial-onboarding-wizard .editor-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
#tutorial-onboarding-wizard .editor-actions .btn {
  height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 16px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
}
#tutorial-onboarding-wizard .tutorial-form-carousel {
  min-width: 0;
}
#tutorial-onboarding-wizard .tutorial-form-carousel-track {
  display: block;
}
#tutorial-onboarding-wizard .tutorial-form-slide {
  width: 100%;
  padding-right: 1px;
}
#tutorial-onboarding-wizard .tutorial-form-slide:not([active]) {
  display: none;
}
#tutorial-onboarding-wizard .editor-card {
  padding: 22px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid var(--brand-border);
}
#tutorial-onboarding-wizard .editor-card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 22px;
}
#tutorial-onboarding-wizard .editor-card-title h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
}
#tutorial-onboarding-wizard .editor-card-title .wizard-of {
  font-size: 0.82rem;
  white-space: nowrap;
  color: var(--muted);
}
#tutorial-onboarding-wizard .step-pill {
  display: inline-grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 0.9rem;
  font-weight: 700;
  background: var(--brand-soft);
  color: var(--brand-dark);
}
#tutorial-onboarding-wizard .w-field {
  margin-bottom: 22px;
}
#tutorial-onboarding-wizard .w-field:last-child {
  margin-bottom: 0;
}
#tutorial-onboarding-wizard .w-field.is-disabled {
  opacity: 0.45;
  pointer-events: none;
}
#tutorial-onboarding-wizard .w-info {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-bottom: 10px;
  color: var(--muted);
  font-size: 0.8rem;
  line-height: 1.45;
}
#tutorial-onboarding-wizard .w-info i {
  color: var(--brand);
  margin-top: 1px;
  font-size: 0.75rem;
}
#tutorial-onboarding-wizard .opt-desc {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-height: 58px;
  margin-top: 10px;
  padding: 9px 12px;
  border-left: 3px solid var(--brand);
  border-radius: 8px;
  background: var(--bg);
  color: var(--ink);
  font-size: 0.82rem;
  line-height: 1.45;
  transition: background 0.15s ease;
}
#tutorial-onboarding-wizard .opt-desc i {
  color: var(--brand);
  margin-top: 1px;
  font-size: 0.75rem;
}
#tutorial-onboarding-wizard .opt-desc.is-placeholder {
  background: transparent;
  border-left-color: var(--brand-border);
  color: var(--muted);
}
#tutorial-onboarding-wizard .opt-desc.is-placeholder i {
  color: var(--muted);
}
#tutorial-onboarding-wizard .fl-group-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
  font-size: 0.92rem;
  font-weight: 600;
}
#tutorial-onboarding-wizard .page-range {
  display: flex;
  align-items: center;
  gap: 8px;
}
#tutorial-onboarding-wizard .page-range part-input {
  flex: 0 1 90px;
  min-width: 0;
}
#tutorial-onboarding-wizard .page-range span {
  flex: 0 0 auto;
  color: var(--muted);
}
#tutorial-onboarding-wizard .scan-field-description {
  margin-top: 10px;
}
#tutorial-onboarding-wizard .bulk-link {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--action);
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
}
#tutorial-onboarding-wizard .bulk-link:hover {
  color: var(--brand-dark);
}
#tutorial-onboarding-wizard .char-count {
  margin-top: 4px;
  text-align: right;
  color: var(--muted);
  font-size: 0.75rem;
}
#tutorial-onboarding-wizard .range-field .w-info {
  margin-bottom: 6px;
}
#tutorial-onboarding-wizard .opt-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 2px 12px;
}
#tutorial-onboarding-wizard .opt-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
#tutorial-onboarding-wizard .w-estimate {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 0.86rem;
  margin-top: 28px;
  background: var(--brand-soft);
  color: var(--brand-dark);
}
#tutorial-onboarding-wizard .w-estimate i {
  margin-top: 1px;
}
#tutorial-onboarding-wizard .w-estimate.is-warn {
  background: #fff4e0;
  color: #9a6206;
}
#tutorial-onboarding-wizard .editor-foot-actions {
  position: static;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 20px;
  padding: 14px 18px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid var(--brand-border);
}
#tutorial-onboarding-wizard .editor-foot-actions .efa-hint {
  min-width: 0;
  font-size: 0.88rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#tutorial-onboarding-wizard .editor-foot-actions .efa-hint strong {
  color: var(--ink);
  font-weight: 600;
}
#tutorial-onboarding-wizard .editor-nav {
  position: static;
  margin-top: 20px;
  background: #fff;
  border: 1px solid var(--brand-border);
  border-radius: 14px;
  box-shadow: none;
}
#tutorial-onboarding-wizard .editor-nav .editor-nav-progress {
  height: 3px;
  background: var(--brand-soft);
}
#tutorial-onboarding-wizard .editor-nav .editor-nav-progress span {
  display: block;
  height: 100%;
  width: 0;
  background: var(--brand);
  transition: width 0.25s ease;
}
#tutorial-onboarding-wizard .editor-nav .editor-nav-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 10px;
  padding-bottom: 10px;
}
#tutorial-onboarding-wizard .editor-nav .nav-arrow {
  height: 48px;
  min-width: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 16px;
  border: 1px solid var(--action);
  border-radius: 8px;
  background: #fff;
  color: var(--action);
  font-weight: 600;
  font-size: 0.9rem;
  flex-shrink: 0;
}
#tutorial-onboarding-wizard .editor-nav .nav-arrow:hover:not(:disabled) {
  background: var(--action);
  color: #fff;
}
#tutorial-onboarding-wizard .editor-nav .nav-arrow:disabled {
  border-color: var(--brand-border);
  color: var(--muted);
  background: #fff;
  opacity: 0.6;
}
#tutorial-onboarding-wizard .editor-nav .nav-arrow-next:not(:disabled) {
  background: var(--action);
  color: #fff;
}
#tutorial-onboarding-wizard .editor-nav .nav-arrow-next:not(:disabled):hover {
  background: var(--action-dark);
  border-color: var(--action-dark);
}
#tutorial-onboarding-wizard .editor-nav .slide-picker {
  position: relative;
  flex: 0 1 560px;
  min-width: 0;
  display: flex;
  justify-content: center;
}
#tutorial-onboarding-wizard .editor-nav .slide-picker-toggle {
  width: 100%;
  max-width: 560px;
  height: 48px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 12px 0 9px;
  border: 1px solid var(--brand-border);
  border-radius: 10px;
  background: #fff;
  color: var(--ink);
  text-align: left;
  cursor: pointer;
}
#tutorial-onboarding-wizard .editor-nav .slide-picker-toggle:hover, #tutorial-onboarding-wizard .editor-nav .slide-picker-toggle[aria-expanded=true] {
  border-color: var(--brand);
}
#tutorial-onboarding-wizard .editor-nav .slide-picker-toggle .sp-caret {
  flex-shrink: 0;
  color: var(--muted);
}
#tutorial-onboarding-wizard .editor-nav .slide-picker-menu {
  display: none;
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  width: min(560px, 100vw - 32px);
  max-height: 60vh;
  overflow-y: auto;
  padding: 6px;
  margin: 0;
  border: 1px solid var(--brand-border);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 -14px 34px -18px rgba(31, 44, 85, 0.35);
  list-style: none;
  z-index: 1050;
}
#tutorial-onboarding-wizard .editor-nav .slide-picker-menu.show {
  display: block;
}
#tutorial-onboarding-wizard .editor-nav .slide-picker-menu li {
  list-style: none;
}
#tutorial-onboarding-wizard .editor-nav .slide-picker-menu .dropdown-header {
  padding: 8px 10px 4px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--muted);
}
#tutorial-onboarding-wizard .editor-nav .slide-picker-menu .slide-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  white-space: normal;
  color: var(--ink);
  text-align: left;
  cursor: pointer;
}
#tutorial-onboarding-wizard .editor-nav .slide-picker-menu .slide-item:hover, #tutorial-onboarding-wizard .editor-nav .slide-picker-menu .slide-item:focus {
  background: var(--bg);
  color: var(--ink);
}
#tutorial-onboarding-wizard .editor-nav .slide-picker-menu .slide-item.active, #tutorial-onboarding-wizard .editor-nav .slide-picker-menu .slide-item:active {
  background: var(--brand-soft);
  color: var(--ink);
}
#tutorial-onboarding-wizard .editor-nav .slide-picker-menu .slide-item.active .sp-num, #tutorial-onboarding-wizard .editor-nav .slide-picker-menu .slide-item:active .sp-num {
  background: var(--brand);
  color: #fff;
}
#tutorial-onboarding-wizard .editor-toast {
  position: fixed;
  left: 50%;
  bottom: 24px;
  z-index: 1040;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: calc(100vw - 32px);
  padding: 10px 16px;
  border-radius: 10px;
  background: var(--wf-navy);
  color: #fff;
  font-size: 0.9rem;
  box-shadow: 0 14px 34px -14px rgba(31, 44, 85, 0.5);
  opacity: 0;
  pointer-events: none;
  transform: translate(-50%, 10px);
  transition: opacity 0.2s ease, transform 0.2s ease;
}
#tutorial-onboarding-wizard .editor-toast.show {
  opacity: 1;
  transform: translate(-50%, 0);
}
#tutorial-onboarding-wizard .editor-toast i {
  color: var(--wf-teal);
}
#tutorial-onboarding-wizard .editor-toast.is-error {
  background: var(--wf-red);
}
#tutorial-onboarding-wizard .editor-toast.is-error i {
  color: #fff;
}
#tutorial-onboarding-wizard .sp-num {
  display: inline-grid;
  place-items: center;
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 0.82rem;
  font-weight: 700;
}
#tutorial-onboarding-wizard .sp-text {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  line-height: 1.25;
}
#tutorial-onboarding-wizard .sp-text strong {
  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#tutorial-onboarding-wizard .sp-text small {
  font-size: 0.74rem;
}
#tutorial-onboarding-wizard .sp-caret {
  font-size: 0.75rem;
}
@media (max-width: 575px) {
  #tutorial-onboarding-wizard .editor-head {
    flex-wrap: wrap;
  }
  #tutorial-onboarding-wizard .editor-head .editor-actions {
    width: 100%;
  }
  #tutorial-onboarding-wizard .editor-head .editor-actions .btn {
    flex: 1;
    justify-content: center;
  }
  #tutorial-onboarding-wizard .editor-foot-actions {
    flex-direction: column;
    align-items: stretch;
  }
  #tutorial-onboarding-wizard .editor-foot-actions .editor-actions .btn {
    flex: 1;
    justify-content: center;
  }
  #tutorial-onboarding-wizard .nav-arrow {
    padding: 0;
  }
}`;
const shadowOptions = { "mode": "open" };
let TutorialOnboardingWizard = class TutorialOnboardingWizard extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.categoryOptions = [];
        this.availableAvatars = [];
        this.goalOptions = [
            { label: 'tutorial.form.onboarding.goals.knowledge'.t(), value: 'knowledge', info: 'tutorial.form.onboarding.descs.goals.knowledge'.t() },
            { label: 'tutorial.form.onboarding.goals.skills'.t(), value: 'skills', info: 'tutorial.form.onboarding.descs.goals.skills'.t() },
            { label: 'tutorial.form.onboarding.goals.certification'.t(), value: 'certification', info: 'tutorial.form.onboarding.descs.goals.certification'.t() },
            { label: 'tutorial.form.onboarding.goals.process_implementation'.t(), value: 'process_implementation', info: 'tutorial.form.onboarding.descs.goals.process_implementation'.t() },
            { label: 'tutorial.form.onboarding.goals.sales_increase'.t(), value: 'sales_increase', info: 'tutorial.form.onboarding.descs.goals.sales_increase'.t() },
            { label: 'tutorial.form.onboarding.goals.company_automation'.t(), value: 'company_automation', info: 'tutorial.form.onboarding.descs.goals.company_automation'.t() },
            { label: 'tutorial.form.onboarding.goals.career_growth'.t(), value: 'career_growth', info: 'tutorial.form.onboarding.descs.goals.career_growth'.t() },
            { label: 'tutorial.form.onboarding.goals.exam_preparation'.t(), value: 'exam_preparation', info: 'tutorial.form.onboarding.descs.goals.exam_preparation'.t() }
        ];
        this.levelOptions = [
            { label: 'tutorial.form.onboarding.levels.beginner'.t(), value: 'beginner', info: 'tutorial.form.onboarding.descs.levels.beginner'.t() },
            { label: 'tutorial.form.onboarding.levels.intermediate'.t(), value: 'intermediate', info: 'tutorial.form.onboarding.descs.levels.intermediate'.t() },
            { label: 'tutorial.form.onboarding.levels.advanced'.t(), value: 'advanced', info: 'tutorial.form.onboarding.descs.levels.advanced'.t() },
            { label: 'tutorial.form.onboarding.levels.expert'.t(), value: 'expert', info: 'tutorial.form.onboarding.descs.levels.expert'.t() }
        ];
        this.industryOptions = [
            { label: 'tutorial.form.onboarding.industries.b2b'.t(), value: 'b2b', info: 'tutorial.form.onboarding.descs.industries.b2b'.t() },
            { label: 'tutorial.form.onboarding.industries.ecommerce'.t(), value: 'ecommerce', info: 'tutorial.form.onboarding.descs.industries.ecommerce'.t() },
            { label: 'tutorial.form.onboarding.industries.services'.t(), value: 'services', info: 'tutorial.form.onboarding.descs.industries.services'.t() },
            { label: 'tutorial.form.onboarding.industries.production'.t(), value: 'production', info: 'tutorial.form.onboarding.descs.industries.production'.t() },
            { label: 'tutorial.form.onboarding.industries.accounting'.t(), value: 'accounting', info: 'tutorial.form.onboarding.descs.industries.accounting'.t() },
            { label: 'tutorial.form.onboarding.industries.it'.t(), value: 'it', info: 'tutorial.form.onboarding.descs.industries.it'.t() },
            { label: 'tutorial.form.onboarding.industries.education'.t(), value: 'education', info: 'tutorial.form.onboarding.descs.industries.education'.t() },
            { label: 'tutorial.form.onboarding.industries.real_estate'.t(), value: 'real_estate', info: 'tutorial.form.onboarding.descs.industries.real_estate'.t() },
            { label: 'tutorial.form.onboarding.industries.medicine'.t(), value: 'medicine', info: 'tutorial.form.onboarding.descs.industries.medicine'.t() },
            { label: 'tutorial.form.onboarding.industries.other'.t(), value: 'other', info: 'tutorial.form.onboarding.descs.industries.other'.t() }
        ];
        this.targetGroupOptions = [
            { label: 'tutorial.form.onboarding.targetGroups.business_owners'.t(), value: 'business_owners', info: 'tutorial.form.onboarding.descs.targetGroups.business_owners'.t() },
            { label: 'tutorial.form.onboarding.targetGroups.ceo'.t(), value: 'ceo', info: 'tutorial.form.onboarding.descs.targetGroups.ceo'.t() },
            { label: 'tutorial.form.onboarding.targetGroups.managers'.t(), value: 'managers', info: 'tutorial.form.onboarding.descs.targetGroups.managers'.t() },
            { label: 'tutorial.form.onboarding.targetGroups.sales'.t(), value: 'sales', info: 'tutorial.form.onboarding.descs.targetGroups.sales'.t() },
            { label: 'tutorial.form.onboarding.targetGroups.hr'.t(), value: 'hr', info: 'tutorial.form.onboarding.descs.targetGroups.hr'.t() },
            { label: 'tutorial.form.onboarding.targetGroups.marketing'.t(), value: 'marketing', info: 'tutorial.form.onboarding.descs.targetGroups.marketing'.t() },
            { label: 'tutorial.form.onboarding.targetGroups.developers'.t(), value: 'developers', info: 'tutorial.form.onboarding.descs.targetGroups.developers'.t() },
            { label: 'tutorial.form.onboarding.targetGroups.freelancers'.t(), value: 'freelancers', info: 'tutorial.form.onboarding.descs.targetGroups.freelancers'.t() },
            { label: 'tutorial.form.onboarding.targetGroups.employees'.t(), value: 'employees', info: 'tutorial.form.onboarding.descs.targetGroups.employees'.t() }
        ];
        this.participantsOptions = [
            { label: 'tutorial.form.onboarding.participants.1-10'.t(), value: '1-10', info: 'tutorial.form.onboarding.descs.participants.1-10'.t() },
            { label: 'tutorial.form.onboarding.participants.10-50'.t(), value: '10-50', info: 'tutorial.form.onboarding.descs.participants.10-50'.t() },
            { label: 'tutorial.form.onboarding.participants.50-200'.t(), value: '50-200', info: 'tutorial.form.onboarding.descs.participants.50-200'.t() },
            { label: 'tutorial.form.onboarding.participants.200-1000'.t(), value: '200-1000', info: 'tutorial.form.onboarding.descs.participants.200-1000'.t() },
            { label: 'tutorial.form.onboarding.participants.1000+'.t(), value: '1000+', info: 'tutorial.form.onboarding.descs.participants.1000+'.t() }
        ];
        this.lessonDurationOptions = [
            { label: '3 min', value: 3, info: 'tutorial.form.onboarding.descs.lessonMinutes.3'.t() },
            { label: '5 min', value: 5, info: 'tutorial.form.onboarding.descs.lessonMinutes.5'.t() },
            { label: '10 min', value: 10, info: 'tutorial.form.onboarding.descs.lessonMinutes.10'.t() },
            { label: '15 min', value: 15, info: 'tutorial.form.onboarding.descs.lessonMinutes.15'.t() },
            { label: '20 min', value: 20, info: 'tutorial.form.onboarding.descs.lessonMinutes.20'.t() },
            { label: '30 min', value: 30, info: 'tutorial.form.onboarding.descs.lessonMinutes.30'.t() },
            { label: '45 min', value: 45, info: 'tutorial.form.onboarding.descs.lessonMinutes.45'.t() },
            { label: '60 min', value: 60, info: 'tutorial.form.onboarding.descs.lessonMinutes.60'.t() }
        ];
        this.intensityOptions = [
            { label: 'tutorial.form.onboarding.intensities.micro_learning'.t(), value: 'micro_learning', info: 'tutorial.form.onboarding.descs.intensities.micro_learning'.t() },
            { label: 'tutorial.form.onboarding.intensities.standard'.t(), value: 'standard', info: 'tutorial.form.onboarding.descs.intensities.standard'.t() },
            { label: 'tutorial.form.onboarding.intensities.academy'.t(), value: 'academy', info: 'tutorial.form.onboarding.descs.intensities.academy'.t() },
            { label: 'tutorial.form.onboarding.intensities.masterclass'.t(), value: 'masterclass', info: 'tutorial.form.onboarding.descs.intensities.masterclass'.t() }
        ];
        this.styleOptions = [
            { label: 'tutorial.form.onboarding.styles.expert'.t(), value: 'expert', info: 'tutorial.form.onboarding.descs.styles.expert'.t() },
            { label: 'tutorial.form.onboarding.styles.business'.t(), value: 'business', info: 'tutorial.form.onboarding.descs.styles.business'.t() },
            { label: 'tutorial.form.onboarding.styles.formal'.t(), value: 'formal', info: 'tutorial.form.onboarding.descs.styles.formal'.t() },
            { label: 'tutorial.form.onboarding.styles.practical'.t(), value: 'practical', info: 'tutorial.form.onboarding.descs.styles.practical'.t() },
            { label: 'tutorial.form.onboarding.styles.coaching'.t(), value: 'coaching', info: 'tutorial.form.onboarding.descs.styles.coaching'.t() },
            { label: 'tutorial.form.onboarding.styles.storytelling'.t(), value: 'storytelling', info: 'tutorial.form.onboarding.descs.styles.storytelling'.t() },
            { label: 'tutorial.form.onboarding.styles.mentoring'.t(), value: 'mentoring', info: 'tutorial.form.onboarding.descs.styles.mentoring'.t() },
            { label: 'tutorial.form.onboarding.styles.workshop'.t(), value: 'workshop', info: 'tutorial.form.onboarding.descs.styles.workshop'.t() }
        ];
        this.toneOptions = [
            { label: 'tutorial.form.onboarding.tones.professional'.t(), value: 'professional', info: 'tutorial.form.onboarding.descs.tones.professional'.t() },
            { label: 'tutorial.form.onboarding.tones.friendly'.t(), value: 'friendly', info: 'tutorial.form.onboarding.descs.tones.friendly'.t() },
            { label: 'tutorial.form.onboarding.tones.dynamic'.t(), value: 'dynamic', info: 'tutorial.form.onboarding.descs.tones.dynamic'.t() },
            { label: 'tutorial.form.onboarding.tones.premium'.t(), value: 'premium', info: 'tutorial.form.onboarding.descs.tones.premium'.t() },
            { label: 'tutorial.form.onboarding.tones.corporate'.t(), value: 'corporate', info: 'tutorial.form.onboarding.descs.tones.corporate'.t() }
        ];
        this.materialOptions = [
            { label: 'tutorial.form.onboarding.materials.outline'.t(), value: 'outline', info: 'tutorial.form.onboarding.descs.materials.outline'.t() },
            { label: 'tutorial.form.onboarding.materials.full_lessons'.t(), value: 'full_lessons', info: 'tutorial.form.onboarding.descs.materials.full_lessons'.t() },
            { label: 'tutorial.form.onboarding.materials.presentations'.t(), value: 'presentations', info: 'tutorial.form.onboarding.descs.materials.presentations'.t() },
            { label: 'tutorial.form.onboarding.materials.pdf'.t(), value: 'pdf', info: 'tutorial.form.onboarding.descs.materials.pdf'.t() },
            { label: 'tutorial.form.onboarding.materials.workbook'.t(), value: 'workbook', info: 'tutorial.form.onboarding.descs.materials.workbook'.t() },
            { label: 'tutorial.form.onboarding.materials.checklists'.t(), value: 'checklists', info: 'tutorial.form.onboarding.descs.materials.checklists'.t() },
            { label: 'tutorial.form.onboarding.materials.quizzes'.t(), value: 'quizzes', info: 'tutorial.form.onboarding.descs.materials.quizzes'.t() },
            { label: 'tutorial.form.onboarding.materials.exams'.t(), value: 'exams', info: 'tutorial.form.onboarding.descs.materials.exams'.t() },
            { label: 'tutorial.form.onboarding.materials.certificate'.t(), value: 'certificate', info: 'tutorial.form.onboarding.descs.materials.certificate'.t() },
            { label: 'tutorial.form.onboarding.materials.practical_tasks'.t(), value: 'practical_tasks', info: 'tutorial.form.onboarding.descs.materials.practical_tasks'.t() },
            { label: 'tutorial.form.onboarding.materials.worksheets'.t(), value: 'worksheets', info: 'tutorial.form.onboarding.descs.materials.worksheets'.t() },
            { label: 'tutorial.form.onboarding.materials.prompt_pack'.t(), value: 'prompt_pack', info: 'tutorial.form.onboarding.descs.materials.prompt_pack'.t() },
            { label: 'tutorial.form.onboarding.materials.case_study'.t(), value: 'case_study', info: 'tutorial.form.onboarding.descs.materials.case_study'.t() },
            { label: 'tutorial.form.onboarding.materials.landing_page'.t(), value: 'landing_page', info: 'tutorial.form.onboarding.descs.materials.landing_page'.t() },
            { label: 'tutorial.form.onboarding.materials.sales_webinar'.t(), value: 'sales_webinar', info: 'tutorial.form.onboarding.descs.materials.sales_webinar'.t() },
            { label: 'tutorial.form.onboarding.materials.email_campaign'.t(), value: 'email_campaign', info: 'tutorial.form.onboarding.descs.materials.email_campaign'.t() },
            { label: 'tutorial.form.onboarding.materials.social_posts'.t(), value: 'social_posts', info: 'tutorial.form.onboarding.descs.materials.social_posts'.t() },
            { label: 'tutorial.form.onboarding.materials.meta_ads'.t(), value: 'meta_ads', info: 'tutorial.form.onboarding.descs.materials.meta_ads'.t() },
            { label: 'tutorial.form.onboarding.materials.google_ads'.t(), value: 'google_ads', info: 'tutorial.form.onboarding.descs.materials.google_ads'.t() }
        ];
        this.imageStyleOptions = buildOptions('imageStyles', tutorial_onboarding_types_1.default.ONBOARDING_IMAGE_STYLES);
        this.currentStepIndex = 0;
        this.isStepMenuOpen = false;
        this.toastMessage = '';
        this.toastError = false;
        this.scanProgressPhase = '';
        this.scanProgressCurrentSection = 0;
        this.scanProgressTotalSections = 0;
        this.scanProgressSectionTitle = '';
        this.sourceFile = null;
        this.scanPagesFrom = null;
        this.scanPagesTo = null;
        this.wizardSteps = [
            { title: 'tutorial.form.onboarding.step1'.t(), hint: 'tutorial.form.onboarding.step1.hint'.t() },
            { title: 'tutorial.form.onboarding.step2'.t(), hint: 'tutorial.form.onboarding.step2.hint'.t() },
            { title: 'tutorial.form.onboarding.step3'.t(), hint: 'tutorial.form.onboarding.step3.hint'.t() },
            { title: 'tutorial.form.onboarding.step4'.t(), hint: 'tutorial.form.onboarding.step4.hint'.t() },
            { title: 'tutorial.form.onboarding.step5'.t(), hint: 'tutorial.form.onboarding.step5.hint'.t() },
            { title: 'tutorial.form.onboarding.step6'.t(), hint: 'tutorial.form.onboarding.step6.hint'.t() },
            { title: 'tutorial.form.onboarding.step7'.t(), hint: 'tutorial.form.onboarding.step7.hint'.t() }
        ];
        this.form = {
            basics: { name: '', categoryId: null, avatarId: null, goals: [], description: '' },
            audience: { level: 'beginner', industries: [], targetGroups: [], participants: '1-10' },
            params: { totalHours: 10, modulesCount: 5, lessonsPerModule: 5, lessonMinutes: 10, intensity: 'standard' },
            style: { styles: [], tone: 'professional' },
            materials: ['outline', 'full_lessons'],
            multimedia: { aiAvatar: false, slides: false, narration: false, quizVideo: false, graphics: false, graphicsStyle: 'corporate' },
            learningModel: { theoryPracticeRatio: 50, exercisesCount: 10, caseStudiesCount: 2, finalProject: false, finalExam: false },
            certification: { certificate: false, passThreshold: 70, numbered: false, qrVerification: false }
        };
        this.sendSubmit = component_2.FormComponent.sendSubmitEvent;
        this.handleStepMenuOutsideClick = (event) => {
            if (!event.composedPath().includes(this)) {
                this.closeStepMenu();
            }
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        document.addEventListener('click', this.handleStepMenuOutsideClick);
        if (this.onboardingLoaded) {
            this.applyOnboardingPayload(this.onboardingLoaded);
        }
        this.on(events_1.inputEvents.changed, (event) => {
            const { fieldName, value } = event.detail;
            if (typeof fieldName === 'string' && fieldName.includes('.')) {
                this.setFieldValue(fieldName, value);
            }
            else if (fieldName === 'scanPagesFrom' || fieldName === 'scanPagesTo') {
                this[fieldName] = value !== '' && value != null ? Number(value) : null;
            }
        });
        this.on('file-part:clear', () => {
            this.sourceFile = null;
        });
        await Promise.all([
            this.getCategories(),
            this.loadAvatars()
        ]);
    }
    async loadAvatars() {
        try {
            const response = await this.apiService.back.get('avatar.list');
            if (response && response.success && Array.isArray(response.data)) {
                this.availableAvatars = response.data;
            }
        }
        catch (error) {
            console.error('Failed to load avatars:', error);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('click', this.handleStepMenuOutsideClick);
    }
    toggleStepMenu(event) {
        event.stopPropagation();
        this.isStepMenuOpen = !this.isStepMenuOpen;
    }
    closeStepMenu() {
        this.isStepMenuOpen = false;
    }
    onboardingLoadedChanged(_oldValue, newValue) {
        if (newValue) {
            this.applyOnboardingPayload(newValue);
        }
    }
    applyOnboardingPayload(payload) {
        var _a;
        this.form = {
            basics: {
                name: payload.basics.name,
                categoryId: payload.basics.categoryId,
                avatarId: (_a = payload.basics.avatarId) !== null && _a !== void 0 ? _a : null,
                goals: [...payload.basics.goals],
                description: payload.basics.description
            },
            audience: {
                ...payload.audience,
                industries: [...payload.audience.industries],
                targetGroups: [...payload.audience.targetGroups]
            },
            params: { ...payload.params },
            style: { ...payload.style, styles: [...payload.style.styles] },
            materials: [...payload.materials],
            multimedia: { ...payload.multimedia },
            learningModel: { ...payload.learningModel },
            certification: { ...payload.certification }
        };
    }
    setFieldValue(path, rawValue) {
        const [section, key] = path.split('.');
        const value = NUMERIC_FIELDS.includes(path) ? Number(rawValue) : rawValue;
        this.form = {
            ...this.form,
            [section]: { ...this.form[section], [key]: value }
        };
    }
    async getCategories() {
        const response = await this.apiService.back.get('tutorial.category.list', { queryParams: { all: '1' } });
        if (response && response.success && Array.isArray(response.data)) {
            this.categoryOptions = [
                { label: 'tutorial.form.no_cat'.t(), value: '' },
                ...response.data.map(item => ({ label: item.name, value: Number(item.id) }))
            ];
        }
        else {
            this.notifyService.notify('tutorial.category.loadFailed'.t());
        }
    }
    buildPayload() {
        const { basics, audience, params, style, materials, learningModel, certification } = this.form;
        const category = this.categoryOptions.find(option => option.value === basics.categoryId);
        return {
            basics: {
                name: basics.name,
                categoryId: basics.categoryId,
                avatarId: basics.avatarId ? Number(basics.avatarId) : null,
                categoryName: category && basics.categoryId ? category.label : null,
                goals: basics.goals,
                description: basics.description
            },
            audience: { ...audience, industries: [...audience.industries], targetGroups: [...audience.targetGroups] },
            params: { ...params },
            style: { ...style, styles: [...style.styles] },
            materials: [...materials],
            multimedia: { ...this.form.multimedia },
            learningModel: { ...learningModel },
            certification: { ...certification }
        };
    }
    get canGoPrev() {
        return this.currentStepIndex > 0;
    }
    get canGoNext() {
        return this.currentStepIndex < this.wizardSteps.length - 1;
    }
    get progressPercent() {
        return Math.round(((this.currentStepIndex + 1) / this.wizardSteps.length) * 100);
    }
    get currentStepHint() {
        var _a;
        return ((_a = this.wizardSteps[this.currentStepIndex]) === null || _a === void 0 ? void 0 : _a.hint) || '';
    }
    get courseEstimate() {
        const sections = this.form.params.modulesCount * this.form.params.lessonsPerModule;
        const minutes = sections * this.form.params.lessonMinutes;
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        const length = (hours ? hours + ' h ' : '') + (mins ? mins + ' min' : (hours ? '' : '0 min'));
        const diff = Math.abs(minutes / 60 - this.form.params.totalHours) > Math.max(1, this.form.params.totalHours * 0.25);
        return `${sections} sekcji · ok. ${length} materiału` + (diff ? ` – różni się od zakładanego czasu (${this.form.params.totalHours} h).` : '.');
    }
    goToStep(index) {
        this.closeStepMenu();
        this.currentStepIndex = Math.max(0, Math.min(index, this.wizardSteps.length - 1));
    }
    prevStep() {
        this.goToStep(this.currentStepIndex - 1);
    }
    nextStep() {
        this.goToStep(this.currentStepIndex + 1);
    }
    async handleSubmit() {
        if (!this.form.basics.avatarId) {
            this.showToast('tutorial.form.onboarding.avatarRequired'.t(), true);
            return;
        }
        this.loading = true;
        this.scanProgressPhase = 'reading';
        this.scanProgressCurrentSection = 0;
        this.scanProgressTotalSections = 0;
        this.scanProgressSectionTitle = '';
        try {
            const payload = this.buildPayload();
            const { id } = await this.streamGenerate(payload, this.sourceFile, this.scanPagesFrom, this.scanPagesTo);
            component_1.SiteMenu.goto.bind(this)(`/tutorial/edit/${id}`);
        }
        catch (error) {
            this.showToast(error.message || 'Failed to generate tutorial', true);
        }
        finally {
            this.loading = false;
        }
    }
    onSourceFileUpload(event) {
        this.sourceFile = event.data;
    }
    streamGenerate(payload, sourceFile, scanPagesFrom, scanPagesTo) {
        return new Promise((resolve, reject) => {
            const url = this.resolveApiUrl('tutorial.generate');
            const body = JSON.stringify({
                onboardingAttached: payload,
                ...(sourceFile ? { file: sourceFile } : {}),
                ...(scanPagesFrom != null ? { scanPagesFrom } : {}),
                ...(scanPagesTo != null ? { scanPagesTo } : {})
            });
            const token = this.apiService._token || this.apiService.token;
            const headers = { 'Content-Type': 'application/json' };
            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }
            fetch(url, {
                method: 'POST',
                headers,
                body
            })
                .then(response => {
                if (!response.ok || !response.body) {
                    throw new Error(`HTTP ${response.status}`);
                }
                const reader = response.body.getReader();
                const decoder = new TextDecoder();
                let buffer = '';
                const read = () => {
                    return reader.read().then(({ done, value }) => {
                        if (done) {
                            if (this.loading) {
                                reject(new Error('Stream ended without completion'));
                            }
                            return;
                        }
                        buffer += decoder.decode(value, { stream: true });
                        const lines = buffer.split('\n');
                        buffer = lines.pop() || '';
                        let eventName = '';
                        let eventData = '';
                        for (const line of lines) {
                            if (line.startsWith('event:')) {
                                eventName = line.slice(6).trim();
                                eventData = '';
                            }
                            else if (line.startsWith('data:')) {
                                eventData = line.slice(5).trim();
                            }
                            else if (line === '' && eventName) {
                                this.handleScanEvent(eventName, eventData, resolve, reject);
                                eventName = '';
                                eventData = '';
                            }
                        }
                        return read();
                    }).catch(error => {
                        reject(error);
                    });
                };
                return read();
            })
                .catch(error => {
                reject(error);
            });
        });
    }
    handleScanEvent(eventName, eventData, resolve, reject) {
        var _a, _b;
        try {
            const data = JSON.parse(eventData);
            switch (eventName) {
                case 'start':
                    this.scanProgressPhase = 'reading';
                    break;
                case 'progress':
                    this.scanProgressPhase = data.phase || '';
                    this.scanProgressCurrentSection = data.sectionNumber || 0;
                    this.scanProgressTotalSections = data.totalSections || 0;
                    break;
                case 'index':
                    this.scanProgressPhase = 'index';
                    break;
                case 'section':
                    this.scanProgressPhase = 'content';
                    this.scanProgressCurrentSection = data.sectionNumber || 0;
                    this.scanProgressTotalSections = data.totalSections || 0;
                    this.scanProgressSectionTitle = ((_a = data.section) === null || _a === void 0 ? void 0 : _a.title) || '';
                    break;
                case 'complete':
                    this.loading = false;
                    if ((_b = data.data) === null || _b === void 0 ? void 0 : _b.id) {
                        resolve({ id: data.data.id });
                    }
                    else {
                        reject(new Error('Generation completed but no tutorial ID returned'));
                    }
                    break;
                case 'error':
                    this.loading = false;
                    reject(new Error(data.error || 'Generation failed'));
                    break;
            }
        }
        catch (e) {
            // ignore non-JSON lines
        }
    }
    resolveApiUrl(routeName) {
        const back = this.apiService.back;
        if (typeof back.getUrl === 'function') {
            return back.getUrl(routeName);
        }
        if (typeof back.url === 'function') {
            return back.url(routeName);
        }
        if (typeof back.getRouteUrl === 'function') {
            return back.getRouteUrl(routeName);
        }
        const parts = routeName.split('.');
        return `/api/${parts.slice(0, -1).join('/')}/${parts[parts.length - 1]}`;
    }
    cancel() {
        this.$emit('onboarding-cancel');
    }
    isCertificateEnabled() {
        return this.form.certification.certificate;
    }
    getCharCount(fieldPath) {
        var _a;
        const [section, key] = fieldPath.split('.');
        const value = (_a = this.form[section]) === null || _a === void 0 ? void 0 : _a[key];
        return String(value || '').length;
    }
    getTheoryScale() {
        return {
            left: 'tutorial.form.onboarding.theory'.t(),
            right: 'tutorial.form.onboarding.practice'.t()
        };
    }
    areAllMaterialsSelected() {
        return this.materialOptions.length > 0 &&
            this.materialOptions.every(option => this.form.materials.includes(option.value));
    }
    toggleAllMaterials() {
        if (this.areAllMaterialsSelected()) {
            this.form = { ...this.form, materials: [] };
        }
        else {
            this.form = { ...this.form, materials: this.materialOptions.map(option => option.value) };
        }
    }
    showToast(message, isError = false) {
        this.toastMessage = message;
        this.toastError = isError;
        setTimeout(() => {
            this.toastMessage = '';
            this.toastError = false;
        }, 2800);
    }
};
exports.TutorialOnboardingWizard = TutorialOnboardingWizard;
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], TutorialOnboardingWizard.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof tutorial_onboarding_types_1.default !== "undefined" && tutorial_onboarding_types_1.default.ITutorialOnboardingPayload) === "function" ? _a : Object)
], TutorialOnboardingWizard.prototype, "onboardingLoaded", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialOnboardingWizard.prototype, "categoryOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof Array !== "undefined" && Array) === "function" ? _b : Object)
], TutorialOnboardingWizard.prototype, "availableAvatars", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialOnboardingWizard.prototype, "goalOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialOnboardingWizard.prototype, "levelOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialOnboardingWizard.prototype, "industryOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialOnboardingWizard.prototype, "targetGroupOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialOnboardingWizard.prototype, "participantsOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialOnboardingWizard.prototype, "lessonDurationOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialOnboardingWizard.prototype, "intensityOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialOnboardingWizard.prototype, "styleOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialOnboardingWizard.prototype, "toneOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialOnboardingWizard.prototype, "materialOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialOnboardingWizard.prototype, "imageStyleOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialOnboardingWizard.prototype, "currentStepIndex", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TutorialOnboardingWizard.prototype, "isStepMenuOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialOnboardingWizard.prototype, "toastMessage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TutorialOnboardingWizard.prototype, "toastError", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialOnboardingWizard.prototype, "scanProgressPhase", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialOnboardingWizard.prototype, "scanProgressCurrentSection", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialOnboardingWizard.prototype, "scanProgressTotalSections", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TutorialOnboardingWizard.prototype, "scanProgressSectionTitle", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof backendImport_1.IFile !== "undefined" && backendImport_1.IFile) === "function" ? _c : Object)
], TutorialOnboardingWizard.prototype, "sourceFile", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialOnboardingWizard.prototype, "scanPagesFrom", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialOnboardingWizard.prototype, "scanPagesTo", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof tutorial_onboarding_types_1.default !== "undefined" && tutorial_onboarding_types_1.default.ITutorialOnboardingForm) === "function" ? _d : Object)
], TutorialOnboardingWizard.prototype, "form", void 0);
exports.TutorialOnboardingWizard = TutorialOnboardingWizard = __decorate([
    (0, client_1.RWSView)('tutorial-onboarding-wizard', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], TutorialOnboardingWizard);
TutorialOnboardingWizard.defineComponent();
